import {AbstractManager} from "./AbstractManager";
import highlightmanagerHtml from './highlightmanager.html?raw';

export let template = highlightmanagerHtml;

export class viewModel extends AbstractManager {
}
